/**
 * 画面だけの staging (stg--yumesaku-front) のビルドかどうか。
 * ビルドの時に VITE_YUMESAKU_STAGING=1 を渡したときだけ true になり、本番のビルドでは false の定数として畳まれる。
 * staging では計測 (GTM、Sentry、Meta の pixel) を止め、左下に小さな札を出す。理由は notes-sandbox/ops/scratch/2026-10-19/staging/design.md
 */
export const IS_STAGING_BUILD = import.meta.env.VITE_YUMESAKU_STAGING === "1";
